<div class="main">
  <p class="pad-top-20 pad-bottom-10">
    To view and manage your life and business claims, please contact your agent or give us a call.
  </p>
  <p class="claim">
    Life Insurance Claims<br />
    1-800-MYAMFAM (1-800-692-6326), ext. 78080
  </p>
  <p class="claim">
    Commercial Farm &amp; Ranch Claims<br />
    1-800-MYAMFAM (1-800-692-6326), ext. 74298
  </p>
  <p class="claim">
    Business Claims<br />
    1-800-MYAMFAM (1-800-692-6326), ext. 78084
  </p>
</div>
